/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import PhysicalObjectType from './PhysicalObjectType';
import MoserObject from './MoserObject';
//@import com/ibm/bi/platform/moser/common/generated/metadata/PhysicalObjectType (loadtime) // superclass
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (static) // fromJSONHelper

/**
 * A function that is stored in a database instance. For MoserJS it is renamed to the javascript class DbFunction, because function is a reserved javascript keyword. <p>Java class for function element declaration. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;element name="function"&gt; &lt;complexType&gt; &lt;complexContent&gt; &lt;extension base="{}physicalObjectType"&gt; &lt;sequence&gt; &lt;element name="resultDatatype" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="procParameter" type="{}procParameterType" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; &lt;/element&gt; </pre>
 */
export default class DbFunction extends PhysicalObjectType{

	resultDatatype = null;

	procParameter = null;



	/**
	 * Gets the value of the resultDatatype property.
	 * @return {String} possible object is {@link String}
	 */
	getResultDatatype() {
		return this.resultDatatype;
	}

	/**
	 * Sets the value of the resultDatatype property.
	 * @param {String} value allowed object is {@link String}
	 */
	setResultDatatype(value) {
		var oldValue = this.resultDatatype;
		this.resultDatatype = value;
		this._setAndNotify(156, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the procParameter property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the procParameter property. <p> For example, to add a new item, do as follows: <pre> getProcParameter().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link ProcParameterType}
	 */
	getProcParameter() {
		if (!this.procParameter) {
			this.procParameter = [];
		}
		return this.procParameter;
	}

	/**
	 * Gets the value of the <code>procParameter</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>ProcParameterType</code> elements, or <code>null</code> if not set
	 */
	basicGetProcParameter() {
		return this.procParameter;
	}

	/**
	 * Creates a new instance of <code>DbFunction</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> DbFunction</code> object from.
	 * @return {DbFunction} an object of type <code>DbFunction</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createDbFunction();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addProcParameterAt(position, item) {
		this._addAtAndNotify(this.getProcParameter(), position, item, 153, true, false);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addProcParameter(item) {
		this.addProcParameterAt(this.getProcParameter().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeProcParameterAt(position) {
		this._removeAtAndNotify(this.getProcParameter(), position, 153, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeProcParameter(item) {
		var i = this.getProcParameter().indexOf(item);
		if (i >= 0) {
			this.removeProcParameterAt(i);
		}
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "DbFunction";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, false, false, 156, "resultDatatype", null));
		var clazz;
		if (factory) {
			clazz = factory.createProcParameterType().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 153, "procParameter", clazz));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 156:
			this.setResultDatatype((value));
			break;
		default:
			super.set(featureID, value);
		}
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set the value to set
	 * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	 */
	_setList(featureID, value) {
		switch (featureID) {
		case 153:
			this.procParameter = (value);
			break;
		default:
			super._setList(featureID, value);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 156:
			return this.getResultDatatype();
		case 153:
			return this.getProcParameter();
		default:
			return super.get(featureID);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 156:
			return this.getResultDatatype();
		case 153:
			return this.basicGetProcParameter();
		default:
			return super.basicGet(featureID);
		}
	}

	/**
	 * Add the value of a specific feature at a specific position
	 * @param {int} position the array position of the item to be added
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	addAt(featureID, position, value) {
		switch (featureID) {
		case 153:
			this.addProcParameterAt(position, (value));
			break;
		default:
			super.addAt(featureID, position, value);
		}
	}

	/**
	 * Add the value to the end of a specific collection feature
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	add(featureID, value) {
		switch (featureID) {
		case 153:
			this.addProcParameter((value));
			break;
		default:
			super.add(featureID, value);
		}
	}

	/**
	 * Remove the value of a specific feature by index.
	 * @param {int} position the array position of the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	removeAt(featureID, position) {
		switch (featureID) {
		case 153:
			this.removeProcParameterAt(position);
			break;
		default:
			super.removeAt(featureID, position);
		}
	}

	/**
	 * Remove the value from specific feature.
	 * @param {BaseMoserObject} item the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	remove(featureID, item) {
		switch (featureID) {
		case 153:
			this.removeProcParameter((item));
			break;
		default:
			super.remove(featureID, item);
		}
	}
}


// WEBPACK FOOTER //
// ./src/generated/DbFunction.js